import { ProductRecommendationAction, BannerRecommendationAction } from "../../../../lib-components/RecommendedProducts/types.js";
import { createResponsiveImage } from "./create-responsive-image.js";
const convertBannerRecommendationInfo = (recommendation) => {
  const responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
  const action = getBannerRecommendationAction(recommendation.action ?? void 0);
  const link = recommendation.action && action === BannerRecommendationAction.Link && "link" in recommendation.action && recommendation.action.link;
  const discountCode = recommendation.action && action === BannerRecommendationAction.DiscountCode && "discountCode" in recommendation.action && recommendation.action.discountCode;
  return {
    title: recommendation.title,
    description: recommendation.description,
    image: {
      url: responsiveImage.url,
      mobileUrl: responsiveImage.url,
      description: recommendation.description
    },
    action,
    ...link && { link },
    ...discountCode && { discountCode }
  };
};
const getProductRecommendationAction = (action) => {
  if (!action) {
    return;
  }
  if ("hasQuantitySelector" in action && "sku" in action) {
    return action.hasQuantitySelector ? ProductRecommendationAction.AddQuantity : ProductRecommendationAction.AddToCart;
  }
  if ("slug" in action) {
    return ProductRecommendationAction.Redirect;
  }
};
const getBannerRecommendationAction = (action) => {
  if (!action) {
    return;
  }
  if ("link" in action) {
    return BannerRecommendationAction.Link;
  }
  if ("discountCode" in action) {
    return BannerRecommendationAction.DiscountCode;
  }
};
export {
  convertBannerRecommendationInfo,
  getProductRecommendationAction
};
//# sourceMappingURL=mappers.js.map
